<template>
  <div class="spo-card rounded p-2 my-3" v-if="!mainStore.bookingSystem.groupe.is_lien_groupe">
    <div class="d-flex items-center gap my-3">
      <v-icon icon="mdi-account-group" color="primary"></v-icon>
      <h4 class="font-weight-bold">Mon groupe</h4>
    </div>

    <div v-if="mainStore.bookingSystem.groupe.is_lien_groupe">
      <p>Vous avez été invité par l'organisateur à inscrire votre groupe (reference: {{
        mainStore.bookingSystem.groupe.token }}). <b>{{ mainStore.bookingSystem.groupe.get_status }}</b></p>

    </div>
    <!-- <pre>{{ list_champs_formulaire.list }}</pre> -->

    <v-container class="mt-4">
      <v-row>
        <v-col md="6" cols="12" class="py-0">
          <label class="field_label">Identité du responsable du groupe<span class="text-red">*</span></label>
          <v-text-field v-model="mainStore.bookingSystem.groupe.default_fields.responsable_groupe"
            ref="field"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <p>Gagnez du temps, les champs ci-dessous seront appliqués par défaut à tous les coureurs. Vous pourrez
            toujours les modifier ensuite.</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6" cols="12" class="py-0">
          <label class="field_label">Nom de mon groupe/club</label>
          <v-text-field v-model="mainStore.bookingSystem.groupe.default_fields.club" ref="field"></v-text-field>
        </v-col>

        <v-col md="6" cols="12" class="py-0">
          <label class="field_label">Mail</label>
          <v-text-field v-model="mainStore.bookingSystem.groupe.default_fields.mail" ref="field"></v-text-field>
        </v-col>
        <v-col md="6" cols="12" class="py-0">
          <label class="field_label">Téléphone</label>
          <v-text-field v-model="mainStore.bookingSystem.groupe.default_fields.telephone" ref="field"></v-text-field>
        </v-col>
        <v-col md="6" cols="12" class="py-0">
          <label class="field_label">Code postal</label>
          <v-text-field v-model="mainStore.bookingSystem.groupe.default_fields.cp" ref="field"></v-text-field>
        </v-col>
        <v-col md="6" cols="12" class="py-0">
          <label class="field_label">Ville</label>
          <v-text-field v-model="mainStore.bookingSystem.groupe.default_fields.ville" ref="field"></v-text-field>
        </v-col>
        <v-col md="6" cols="12" class="py-0">
          <label class="field_label">Personne à contacter en cas d'urgence</label>
          <v-text-field v-model="mainStore.bookingSystem.groupe.default_fields.contact_urgence"
            ref="field"></v-text-field>
        </v-col>
        <v-col md="6" cols="12" class="py-0">
          <label class="field_label">Téléphone du contact d'urgence</label>
          <v-text-field v-model="mainStore.bookingSystem.groupe.default_fields.tel_contact_urgence"
            ref="field"></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
  components: {},
  data() {
    return {
      groupe_default_fields: {
        club: "",
        mail: "",
        telephone: "",
        cp: "",
        ville: "",
        contact_urgence: "",
        tel_contact_urgence: "",
        responsable_groupe: "",
        token: "",
      },
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  async created() {
    if (!this.mainStore.bookingSystem.groupe.default_fields) {
      this.mainStore.bookingSystem.groupe.default_fields = this.groupe_default_fields;
    }
  },
};
</script>

<style lang="scss" scoped></style>